// Toggle .js-toggle only when radio[value="(4言語のいずれか)"] is checked
(() => {
  const RADIO_SELECTOR =
    'input.smf-radio-button-control__control[type="radio"]';

  // ★ 4言語の value を配列で許可
  const TARGET_VALUES = [
    '観光パンフレット請求',
    '觀光手冊索取',
    'Request for tourism brochures',
    'ขอรับโบรชัวร์ท่องเที่ยว',
  ];

  const TOGGLE_SELECTOR = '.js-toggle';

  const showAllToggles = (): void => {
    document.querySelectorAll<HTMLElement>(TOGGLE_SELECTOR).forEach((el) => {
      if (el.classList.contains('!hidden')) el.classList.remove('!hidden');
      el.style.display = '';
    });
  };

  const hideAllToggles = (): void => {
    document.querySelectorAll<HTMLElement>(TOGGLE_SELECTOR).forEach((el) => {
      if (!el.classList.contains('!hidden')) el.classList.add('!hidden');
      el.style.display = 'none';
    });
  };

  const isTargetChecked = (): boolean => {
    // TARGET_VALUES のいずれかの value を持つ radio が checked なら true
    return TARGET_VALUES.some((val) => {
      const sel = `${RADIO_SELECTOR}[value="${CSS.escape(val)}"]:checked`;
      return Boolean(document.querySelector<HTMLInputElement>(sel));
    });
  };

  const update = (): void => {
    if (isTargetChecked()) {
      showAllToggles();
    } else {
      hideAllToggles();
    }
  };

  const onChange = (e: Event): void => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (!t.matches(RADIO_SELECTOR)) return;
    update();
  };

  const init = (): void => {
    update(); // 初期状態を反映
    document.addEventListener('change', onChange);

    // フォームのリセットにも対応（必要なければ削除）
    document.addEventListener('reset', () => setTimeout(update, 0));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
